import { Environment } from 'services/Environment';

export const getBookUrl = (
    courseSlug: string,
    educatorSlug: string,
    occurrenceId: string | null,
    embedded: boolean = false,
    parentWindowUrl: string = '',
    utms: string = '',
    listParam: string = '',
    applicationRequired: boolean = false,
    voucherParam: null | string = null
) => {
    let url = `/checkout?course=${courseSlug}&educator=${educatorSlug}`;
    if (occurrenceId) url += `&occurrence=${occurrenceId}`;
    if (listParam) url += `&list=${listParam}`;
    if (applicationRequired) url += `&application_required=true`;
    if (voucherParam) url += `&voucher=${voucherParam}`;
    if (parentWindowUrl) url += `&parent_window_url=${parentWindowUrl}`;
    if (utms) url += `&${utms}`;
    if (embedded) url += `&checkout_embed=true`;

    if (embedded) {
        return `https://${educatorSlug}.${Environment.DOMAIN}` + url + `&origin=embed`;
    }

    return url + `&origin=landing_page`;
};
